export function DedicatedScorerIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="12" y="6" width="24" height="32" rx="2" />
      <line x1="17" y1="14" x2="31" y2="14" />
      <line x1="17" y1="19" x2="31" y2="19" />
      <line x1="17" y1="24" x2="31" y2="24" />
      <line x1="17" y1="29" x2="26" y2="29" />
      <path d="M22 38l2 4 2-4" />
      <circle cx="24" cy="42" r="1.5" fill="currentColor" />
    </svg>
  );
}
